/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  material: [],
});

// State object
const state = initialState();

// Getter functions
const getters = {
  getError:(state) => state.error,
  getMaterial:(state) => state.material
};

// Actions
const actions = {
  requestMaterials({ commit }, material_name) {
    return new Promise((resolve, reject) => {
      if (material_name != '') {
        material_name = material_name.replace(/\s/g, '');
        axios({
          url: `material?name=${material_name}`,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          commit('set_material', resp.data.data.Items);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
      } else {
        commit('set_material', []);
        resolve();
      }
    })
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_material(state, material) {
    state.material = [...material];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
